import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/playbooks`;
export const list         = (wsId)                       => get(base(wsId));
export const create       = (wsId, dto)                  => post(base(wsId), dto);
export const update       = (wsId, id, dto)              => patch(`${base(wsId)}/${id}`, dto);
export const remove       = (wsId, id)                   => del(`${base(wsId)}/${id}`);
export const getWithSteps = (wsId, id)                   => get(`${base(wsId)}/${id}`);
export const addStep      = (wsId, id, dto)              => post(`${base(wsId)}/${id}/steps`, dto);
export const removeStep   = (wsId, id, stepId)           => del(`${base(wsId)}/${id}/steps/${stepId}`);
